var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 116,
    viewBox: "0 0 135 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_1909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.1466 110.451C92.0462 110.451 112.231 90.1376 112.231 65.0792C112.231 40.0208 92.0462 19.707 67.1466 19.707C42.2471 19.707 22.062 40.0208 22.062 65.0792C22.062 90.1376 42.2471 110.451 67.1466 110.451Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7876 110.543H115.406",
    stroke: "#EBF0F6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2807 109.812C82.3865 109.995 74.1316 109.812 68.3259 109.721C62.5202 109.903 54.2653 109.995 47.3711 109.812C54.1746 105.887 56.5331 98.6749 56.896 93.9277H79.6651C80.2094 98.5836 82.5679 105.887 89.2807 109.812Z",
    fill: "url(#paint0_linear_261_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0968 111H88.5551C89.0994 111 89.6436 110.544 89.6436 109.904C89.6436 109.357 89.1901 108.809 88.5551 108.809H48.0968C47.5525 108.809 47.0083 109.265 47.0083 109.904C47.099 110.544 47.5525 111 48.0968 111Z",
    fill: "#EBF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.415 33.4019V93.107C111.415 94.5677 110.235 95.6632 108.875 95.6632H28.2304C26.8697 95.6632 25.6904 94.4764 25.6904 93.107V33.4019C25.6904 32.0325 26.8697 30.8457 28.2304 30.8457H108.875C110.326 30.8457 111.415 32.0325 111.415 33.4019Z",
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.415 33.4019V84.7994H25.6904V33.4019C25.6904 32.0325 26.8697 30.8457 28.2304 30.8457H108.875C110.326 30.8457 111.415 32.0325 111.415 33.4019Z",
    fill: "#172D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.149 34.1328H28.5933V81.9699H108.149V34.1328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4165 92.6506C69.5688 92.6506 70.5029 91.7106 70.5029 90.5509C70.5029 89.3913 69.5688 88.4512 68.4165 88.4512C67.2642 88.4512 66.3301 89.3913 66.3301 90.5509C66.3301 91.7106 67.2642 92.6506 68.4165 92.6506Z",
    fill: "#DBDFE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3639 28.9162C38.555 28.5266 39.2067 27.239 38.8196 26.0403C38.4325 24.8416 37.153 24.1856 35.9619 24.5753C34.7708 24.9649 34.119 26.2525 34.5062 27.4512C34.8933 28.6499 36.1728 29.3058 37.3639 28.9162Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3146 21.4696C43.1246 21.2047 43.5678 20.3291 43.3045 19.514C43.0413 18.6989 42.1713 18.2529 41.3613 18.5178C40.5513 18.7827 40.1081 19.6583 40.3714 20.4734C40.6347 21.2886 41.5047 21.7346 42.3146 21.4696Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.455 52.2371C126.861 50.9446 126.959 48.7502 125.675 47.3359C124.39 45.9215 122.21 45.8228 120.805 47.1153C119.399 48.4078 119.301 50.6021 120.585 52.0164C121.87 53.4308 124.05 53.5296 125.455 52.2371Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.716 36.6836C126.308 36.1393 126.349 35.2154 125.808 34.6199C125.267 34.0244 124.349 33.9828 123.758 34.527C123.166 35.0712 123.125 35.9951 123.665 36.5907C124.206 37.1862 125.124 37.2278 125.716 36.6836Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.691 23.1772C110.493 23.1772 111.143 22.5232 111.143 21.7165C111.143 20.9098 110.493 20.2559 109.691 20.2559C108.89 20.2559 108.24 20.9098 108.24 21.7165C108.24 22.5232 108.89 23.1772 109.691 23.1772Z",
    fill: "url(#paint1_linear_261_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.523 42.8953V49.0119C103.523 49.9248 102.797 50.6551 101.89 50.6551H34.7617C33.8546 50.6551 33.1289 49.9248 33.1289 49.0119V42.8953C33.1289 41.9824 33.8546 41.252 34.7617 41.252H101.89C102.797 41.252 103.523 41.9824 103.523 42.8953Z",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.563 41.252V50.7464H34.671C33.7638 50.7464 33.0381 50.0161 33.0381 49.1032V42.9866C33.0381 42.0737 33.7638 41.3433 34.671 41.3433H42.563V41.252Z",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.523 55.6765V61.793C103.523 62.706 102.797 63.4363 101.89 63.4363H34.7617C33.8546 63.4363 33.1289 62.706 33.1289 61.793V55.6765C33.1289 54.7635 33.8546 54.0332 34.7617 54.0332H101.89C102.797 54.0332 103.523 54.7635 103.523 55.6765Z",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.563 54.0332V63.5276H34.671C33.7638 63.5276 33.0381 62.7972 33.0381 61.8843V55.7677C33.0381 54.8548 33.7638 54.1245 34.671 54.1245H42.563V54.0332Z",
    fill: "#6B84FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4831 60.7892C37.3017 60.7892 37.1203 60.6979 37.0295 60.6066L35.5781 59.1459C35.306 58.8721 35.306 58.4156 35.5781 58.1417C35.8503 57.8678 36.3038 57.8678 36.576 58.1417L37.4831 59.0546L39.6602 56.8636C39.9324 56.5898 40.3859 56.5898 40.6581 56.8636C40.9302 57.1375 40.9302 57.594 40.6581 57.8678L37.9367 60.5153C37.846 60.6979 37.6645 60.7892 37.4831 60.7892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.523 68.4577V74.5743C103.523 75.4872 102.797 76.2176 101.89 76.2176H34.7617C33.8546 76.2176 33.1289 75.4872 33.1289 74.5743V68.4577C33.1289 67.5448 33.8546 66.8145 34.7617 66.8145H101.89C102.797 66.8145 103.523 67.5448 103.523 68.4577Z",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.563 66.8145V76.3089H34.671C33.7638 76.3089 33.0381 75.5785 33.0381 74.6656V68.549C33.0381 67.6361 33.7638 66.9058 34.671 66.9058H42.563V66.8145Z",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.523 81.2389V81.9693H33.0381V81.2389C33.0381 80.326 33.7638 79.5957 34.671 79.5957H101.799C102.797 79.5957 103.523 80.326 103.523 81.2389Z",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.563 79.5957V81.9693H33.0381V81.2389C33.0381 80.326 33.7638 79.5957 34.671 79.5957H42.563Z",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.222 106.527C32.222 108.262 30.8613 109.631 29.1377 109.631H11.9021C10.1786 109.631 8.81787 108.262 8.81787 106.527V66.0845C8.81787 64.3499 10.1786 62.9805 11.9021 62.9805H29.047C30.7706 62.9805 32.1313 64.3499 32.1313 66.0845V106.527H32.222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1377 62.8887C30.8612 62.8887 32.2219 64.2581 32.2219 65.9927V106.435C32.2219 108.17 30.8612 109.539 29.1377 109.539H11.9021C10.1785 109.539 8.81787 108.17 8.81787 106.435V66.0839C8.81787 64.3494 10.1785 62.98 11.9021 62.98H29.1377V62.8887Z",
    fill: "#1C3754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6796 66.085V106.528C30.6796 107.349 30.0446 108.08 29.1375 108.08H29.0468H11.9019H11.8112C10.9948 108.08 10.269 107.349 10.269 106.528V66.085C10.269 65.1721 10.9948 64.5331 11.8112 64.5331H14.3512C14.714 64.5331 14.9861 64.8069 14.9861 65.1721C14.9861 65.8111 15.5304 66.3589 16.1654 66.3589H24.8739C25.5089 66.3589 26.0532 65.8111 26.0532 65.1721C26.0532 64.8069 26.3253 64.5331 26.5975 64.5331H29.0468C29.9539 64.4418 30.6796 65.1721 30.6796 66.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9709 65.0799H19.7031C19.5217 65.0799 19.3403 64.8974 19.3403 64.7148C19.3403 64.5322 19.5217 64.3496 19.7031 64.3496H21.9709C22.1524 64.3496 22.3338 64.5322 22.3338 64.7148C22.3338 64.8974 22.1524 65.0799 21.9709 65.0799Z",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4335 65.0799H18.2521C18.0707 65.0799 17.8892 64.8974 17.8892 64.7148C17.8892 64.5322 18.0707 64.3496 18.2521 64.3496H18.4335C18.6149 64.3496 18.7964 64.5322 18.7964 64.7148C18.7964 64.8974 18.6149 65.0799 18.4335 65.0799Z",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.321 79.5042H12.7183C12.2647 79.5042 11.9019 79.139 11.9019 78.6825V70.8314C11.9019 70.3749 12.2647 70.0098 12.7183 70.0098H28.4117C28.8653 70.0098 29.2282 70.3749 29.2282 70.8314V78.6825C29.1375 79.139 28.7746 79.5042 28.321 79.5042Z",
    fill: "#6B84FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8845 76.7657C19.7031 76.7657 19.5217 76.6744 19.431 76.5831L17.9795 75.1224C17.7074 74.8486 17.7074 74.3921 17.9795 74.1182C18.2517 73.8443 18.7052 73.8443 18.9774 74.1182L19.8845 75.0311L22.0617 72.8401C22.3338 72.5663 22.7874 72.5663 23.0595 72.8401C23.3316 73.114 23.3316 73.5705 23.0595 73.8443L20.4288 76.4918C20.2474 76.6744 20.066 76.7657 19.8845 76.7657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.321 91.2815H12.7183C12.2647 91.2815 11.9019 90.9163 11.9019 90.4599V82.6087C11.9019 82.1523 12.2647 81.7871 12.7183 81.7871H28.4117C28.8653 81.7871 29.2282 82.1523 29.2282 82.6087V90.4599C29.1375 90.9163 28.7746 91.2815 28.321 91.2815Z",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3211 103.149H12.7183C12.2648 103.149 11.9019 102.784 11.9019 102.327V94.476C11.9019 94.0195 12.2648 93.6543 12.7183 93.6543H28.4118C28.8654 93.6543 29.2282 94.0195 29.2282 94.476V102.327C29.1375 102.784 28.7746 103.149 28.3211 103.149Z",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1378 106.434V108.078H29.0471H11.9022H11.8115V106.434C11.8115 105.978 12.1743 105.613 12.6279 105.613H28.3214C28.7749 105.613 29.1378 105.978 29.1378 106.434Z",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9496 37.7828C32.4506 37.7828 32.8568 37.3741 32.8568 36.8699C32.8568 36.3657 32.4506 35.957 31.9496 35.957C31.4486 35.957 31.0425 36.3657 31.0425 36.8699C31.0425 37.3741 31.4486 37.7828 31.9496 37.7828Z",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8525 37.7828C35.3535 37.7828 35.7596 37.3741 35.7596 36.8699C35.7596 36.3657 35.3535 35.957 34.8525 35.957C34.3515 35.957 33.9453 36.3657 33.9453 36.8699C33.9453 37.3741 34.3515 37.7828 34.8525 37.7828Z",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7553 37.7828C38.2563 37.7828 38.6624 37.3741 38.6624 36.8699C38.6624 36.3657 38.2563 35.957 37.7553 35.957C37.2543 35.957 36.8481 36.3657 36.8481 36.8699C36.8481 37.3741 37.2543 37.7828 37.7553 37.7828Z",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_261_1909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.669 88.2779C125.579 88.5518 125.579 88.9169 125.488 89.1908C125.216 90.195 124.944 91.1079 124.49 91.9296C122.404 96.5855 118.413 100.054 113.605 101.424C113.333 101.515 113.06 101.606 112.879 101.606C110.43 102.245 107.799 102.336 105.168 101.789C95.8251 99.8718 89.7472 90.5604 91.7429 81.1573C93.6479 71.7542 102.901 65.6373 112.244 67.6457C115.6 68.3761 118.594 70.0195 120.952 72.3931C125.125 76.5013 126.939 82.5265 125.669 88.2779Z",
    fill: "url(#paint2_linear_261_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.358 84.909C108.358 84.7201 108.511 84.5659 108.701 84.5659C108.89 84.5659 109.044 84.7201 109.044 84.909V90.3227C109.044 90.5123 108.89 90.6658 108.701 90.6658C108.511 90.6658 108.358 90.5123 108.358 90.3227V84.909ZM111.558 84.8749V84.8756C111.566 84.7853 111.61 84.702 111.681 84.6444C111.751 84.5867 111.841 84.559 111.931 84.568C112.119 84.586 112.257 84.7534 112.238 84.9416L111.723 90.3547C111.705 90.5422 111.537 90.6804 111.349 90.6623C111.162 90.6436 111.024 90.4769 111.042 90.2887L111.561 84.8756L111.558 84.8749ZM105.158 84.9409V84.9416C105.14 84.7534 105.277 84.586 105.465 84.568C105.654 84.5499 105.82 84.6874 105.838 84.8756L106.35 90.2887H106.351C106.369 90.4769 106.231 90.6436 106.043 90.6623C105.855 90.6804 105.688 90.5422 105.669 90.3547L105.159 84.9416L105.158 84.9409ZM114.875 82.2305H102.526L103.253 91.1742C103.335 92.2076 104.199 93.0034 105.236 93H112.169C113.204 93.0014 114.066 92.2063 114.148 91.1742L114.875 82.2305ZM106.113 78.8805V78.4083C106.114 77.6312 106.744 77.0021 107.52 77H109.881C110.658 77.0021 111.287 77.6312 111.289 78.4083V78.8812L110.603 78.8805V78.4083C110.601 78.0104 110.278 77.6889 109.881 77.6882H107.52C107.123 77.6889 106.801 78.0104 106.799 78.4083V78.8813L106.113 78.8805ZM102.001 81.5472H115.401V80.5749C115.399 80.0409 114.967 79.6083 114.432 79.6062H102.969C102.435 79.6083 102.002 80.0409 102 80.5749L102.001 81.5472Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_261_1909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8633 19.16C29.954 22.1727 27.5047 24.7288 24.5112 24.8201H23.0597L19.0683 24.9114C13.0812 25.0027 8.18271 20.2555 8.00129 14.1389C7.91057 8.11366 12.6277 3.18388 18.6148 3.00129C24.6019 2.91 29.5911 7.6572 29.7725 13.6825L29.8633 15.9648V19.16Z",
    fill: "url(#paint3_linear_261_1909)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.1631 54.947V53.1211",
    stroke: "#83A0FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1631 49.8348V37.9668",
    stroke: "#83A0FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.7 3.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1631 36.3239V34.498",
    stroke: "#83A0FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0727 59.603C17.7741 59.603 18.3427 59.0308 18.3427 58.325C18.3427 57.6191 17.7741 57.0469 17.0727 57.0469C16.3713 57.0469 15.8027 57.6191 15.8027 58.325C15.8027 59.0308 16.3713 59.603 17.0727 59.603Z",
    stroke: "#83A0FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0727 32.2144C17.7741 32.2144 18.3427 31.6422 18.3427 30.9363C18.3427 30.2305 17.7741 29.6582 17.0727 29.6582C16.3713 29.6582 15.8027 30.2305 15.8027 30.9363C15.8027 31.6422 16.3713 32.2144 17.0727 32.2144Z",
    stroke: "#83A0FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3042 13.8652H38.1184",
    stroke: "#83A0FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7466 13.8652H63.6086C66.7836 13.8652 69.3235 16.4213 69.3235 19.6166V52.4818",
    stroke: "#83A0FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.99 3.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2329 54.2168V56.0427",
    stroke: "#83A0FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4919 14.9605C34.0931 14.9605 34.5804 14.4701 34.5804 13.865C34.5804 13.26 34.0931 12.7695 33.4919 12.7695C32.8907 12.7695 32.4033 13.26 32.4033 13.865C32.4033 14.4701 32.8907 14.9605 33.4919 14.9605Z",
    stroke: "#83A0FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3235 59.9683C69.9247 59.9683 70.412 59.4779 70.412 58.8728C70.412 58.2678 69.9247 57.7773 69.3235 57.7773C68.7223 57.7773 68.2349 58.2678 68.2349 58.8728C68.2349 59.4779 68.7223 59.9683 69.3235 59.9683Z",
    stroke: "#83A0FF",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_261_1909",
    x: 83.3633,
    y: 64.2637,
    width: 50.7046,
    height: 50.8848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.968627 0 0 0 0 0.254902 0 0 0 0 0.564706 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_261_1909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_261_1909",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_261_1909",
    x: 0,
    y: 0,
    width: 37.8657,
    height: 37.9121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_261_1909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_261_1909",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_261_1909",
    x1: 68.372,
    y1: 109.363,
    x2: 68.372,
    y2: 95.1236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9913,
    stopColor: "#D8E0EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_261_1909",
    x1: 108.286,
    y1: 21.6922,
    x2: 111.102,
    y2: 21.6922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_261_1909",
    x1: 91.3651,
    y1: 84.6926,
    x2: 126.066,
    y2: 84.6926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_261_1909",
    x1: 8.00129,
    y1: 13.9387,
    x2: 29.8537,
    y2: 13.9387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_1909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 116,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.8e27cf5feb49294d9f64caf907fee040.svg";
export { ForwardRef as ReactComponent };